/* eslint-disable  no-irregular-whitespace */
import * as React from 'react';

import { ECpdLabelModalView } from 'shared/types/cpd/cpd';

import modalImage1 from './assets/1.jpg';
import modalImage2 from './assets/2.jpg';
import modalImage3 from './assets/3.jpg';
import modalImage4 from './assets/4.jpg';
import styles from './styles.css';

export const MAP_MODAL_CONTENT = {
  [ECpdLabelModalView.Sdelka]: {
    title: 'Объект в Сделке',
    description: (
      <>
        <div className={styles['paragraph']}>
          Со Сделкой на Циане покупка пройдёт гладко. Мы уже проверили объект на наличие арестов и ограничений и
          подобрали надёжного агента. Он расскажет больше про это жильё, поможет с оформлением и проследит за
          безопасностью сделки.
        </div>
        <div>Всё под нашим контролем: если что‑то пойдёт не так — Циан сразу подключится.</div>
      </>
    ),
    actionText: 'Выглядит полезно',
    secondaryActionText: 'Хочу продать своё жильё со Сделкой',
    imgUrl: modalImage1,
  },
  [ECpdLabelModalView.Documents]: {
    title: 'Документы в порядке',
    description: (
      <>
        <div className={styles['paragraph']}>Мы уже проверили самое главное:</div>
        <div className={styles['paragraph']}>
          — есть ли аресты или ограничения в Росреестре <br />
          — проходит ли продавец процедуру банкротства или является банкротом <br />— соответствуют ли данные в выписках
          реальности
        </div>
        <div>Если есть риски — вы узнаете об этом сразу.</div>
      </>
    ),
    actionText: 'Это радует',
    imgUrl: modalImage2,
  },
  [ECpdLabelModalView.Profi]: {
    title: 'Надёжный эксперт',
    description: (
      <>
        <div className={styles['paragraph']}>
          Мы проверили агента, который занимается этим объектом, и доверяем ему. Он внимательно заполняет документы,
          общается вежливо и по делу, о нём оставляют хорошие отзывы другие клиенты.
        </div>
        <div>
          Агент Сделки держит процесс под контролем и помогает решить все вопросы с недвижимостью без лишнего стресса.
        </div>
      </>
    ),
    actionText: 'Сразу видно профессионала',
    imgUrl: modalImage3,
  },
  [ECpdLabelModalView.RealFlat]: {
    title: 'Жильё настоящее',
    description: (
      <div>
        Не нужно верить на слово: агент Сделки посмотрел квартиру лично и убедился, что фото и описание объекта
        соответствуют реальности. Без прикрас и подводных камней — всё как в жизни и в документах.
      </div>
    ),
    actionText: 'Выглядит полезно',
    imgUrl: modalImage4,
  },
};
